import { Outlet, useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import Header from '../header';
import Footer from '../footer';

const Layout = () => {
  const { pathname } = useLocation();

  return (
    <Box>
      <Header />
      <Box
        pt={20}
        sx={{
          background: pathname === '/meme' ? '#E4D2BA' : 'transparent',
          paddingTop: pathname === '/meme' ? '0px' : '30px',
        }}
      >
        <Outlet />
      </Box>
      <Footer />
    </Box>
  );
};

export default Layout;
